import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  SelectInput,
  ArrayInput,
  SimpleFormIterator,
  FileInput,
  FileField,
} from "react-admin";
import { RichTextInput } from "ra-input-rich-text";
import { languageChoices, initialValues } from "../../../utils/options";
import CustomDateInput from "common/components/Fields/CustomDateInput";
import { arrayLabel } from "customStyles/ra-custom-styles";

const CompetitionCreate = () => {
  const transform = data => ({
    ...data,
    files: data.files
      ? data.files.map(fileItem => ({
          name: fileItem.name, // Keep the name as it is
          file: fileItem.file.rawFile, // Directly use the binary file data (rawFile)
        }))
      : null,
  });
  return (
    <>
      <Create
        title="Създаване на конкурс"
        transform={transform}
      >
        <SimpleForm defaultValues={initialValues}>
          <SelectInput
            label="Език"
            source="language"
            choices={languageChoices}
          />
          <TextInput
            label="Име"
            source="title"
            fullWidth
          />{" "}
          <RichTextInput
            label="Съдържание"
            source="content"
            fullWidth
          />{" "}
          <ArrayInput
            source="files"
            label="Качете файл"
            sx={arrayLabel}
          >
            <SimpleFormIterator
              disableReordering
              fullWidth
            >
              <FileInput
                placeholder="Качете файл"
                label="Файл"
                source="file"
                maxSize={54525952}
              >
                <FileField
                  source="src"
                  title="title"
                />
              </FileInput>
              <TextInput
                label="Име на файла"
                source="name"
                fullWidth
              />
            </SimpleFormIterator>
          </ArrayInput>
          <CustomDateInput
            label="Дата на публикуване"
            source="started_on"
          />
          <BooleanInput
            label="Скрита"
            source="is_hidden"
          />
        </SimpleForm>
      </Create>
    </>
  );
};

export default CompetitionCreate;
